// User creator - dynamic form based on role
document.addEventListener('DOMContentLoaded', () => {
  const userRoleInput = document.querySelector('#user_role')
  const userCreatorInput = document.querySelector('#user_creator_id')
  if (!userRoleInput || !userCreatorInput) return

  const userCreatorForm = userCreatorInput.closest('fieldset.inputs') ||
                          userCreatorInput.closest('ol.inputs')
  if (!userCreatorForm) return

  function getUserRole() {
    return userRoleInput.value
  }

  // Dynamic form rules
  function setupUserCreatorInput(userRole) {
    if (userRole === 'customer') {
      userCreatorForm.style.display = ''
    } else {
      resetUserCreatorInput()
      userCreatorForm.style.display = 'none'
    }
  }

  function resetUserCreatorInput() {
    userCreatorInput.value = ''
    userCreatorInput.dispatchEvent(new Event('change', { bubbles: true }))

    // If SlimSelect is initialized, update it
    if (userCreatorInput._slimSelect) {
      userCreatorInput._slimSelect.set('')
    }
  }

  // Initialization
  const initialUserRole = getUserRole()
  setupUserCreatorInput(initialUserRole)

  // Listeners
  userRoleInput.addEventListener('change', (e) => {
    const userRole = getUserRole()
    setupUserCreatorInput(userRole)
  })
})
